import { HttpError } from "./HttpError";

/** Error HTTP 401 (no autorizado / sesión inválida). */
export class UnauthorizedError extends HttpError {
  /** @param message Mensaje de error. */
  constructor(message: string) {
    super(message, 401);
  }
}
